// components/InfoBlock.js
import { Box, Text } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { forwardRef } from "react";

// Преобразуйте Box в анимационный компонент
const MotionBox = motion(Box);
const MotionText = motion(Text);

const InfoBlock = forwardRef(({ label, value, isMobile, note }, ref) => (
	<MotionBox
		bg="#FEF0DD"
		padding={4}
		// borderRadius="1.6rem"
		borderRadius="15px"
		textAlign="center"
		width={isMobile ? 'auto' : "300px"}
		minW={isMobile ? "150px" : 'auto'}
	>
		<MotionText
			fontSize={{ base: "1em", md: "clamp(1em, 2vw, 1.25em)" }}
			initial={{ opacity: 0, y: 20 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 1, delay: 0.3 }}
		>
			{label}
		</MotionText>
		<MotionText
			fontSize={{ base: "1.5em", md: "clamp(1.5em, 2.5vw, 2em)" }}
			fontWeight="bold"
			initial={{ opacity: 0, y: 20 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 1, delay: 1 }}
		>
			<span ref={ref}>{value}</span>{note}
		</MotionText>
	</MotionBox>
));

export default InfoBlock;
